import { ContractingProcessAnswerProps } from 'features/contracting/models/ContractingProcessAnswerProps';
import React from 'react';
import NoPlaceOfDeliveryQuestionsSubForm from 'features/contracting/components/process/NoPlaceOfDeliveryQuestionsSubForm';

interface Props extends ContractingProcessAnswerProps {};

const NoPlaceOfDeliveryNotExistsSubForm = ({ formHandler }: Props) => {
  // render
  return (
    <NoPlaceOfDeliveryQuestionsSubForm 
      formHandler={formHandler}
      objectPrefix="noPlaceOfDeliveryNotExists"
    />
  )
}

export default NoPlaceOfDeliveryNotExistsSubForm;